import './assets/styles/author-card.css'
import '@capsule/svgs-library/capsule-circle-plus.svg'
import '@capsule/svgs-library/capsule-circle-minus.svg'
import AuthorCard from './assets/scripts/author-card.js'
import '@capsule/cta'
import '@capsule/image'

const authorCards = [...document.querySelectorAll('.authorCard')]

authorCards.forEach((card) => {
	const authorCard = new AuthorCard(card as HTMLElement)
	authorCard.init()
})
